import _extends from "@babel/runtime/helpers/extends";
import '../../css-tokens';
import React, { forwardRef } from 'react';
import cx from 'classnames';
import system from '../../system';
import Base from '../Base';
import styles from './index.module.css';
const SYSTEM_PROPS = ['backgroundProps', 'borderProps', 'borderRadiusProps', 'colorProps', 'flexProps', 'flexParentProps', 'heightProps', 'marginProps', 'paddingProps', 'positioningProps', 'textProps', 'widthProps', 'floatProps', 'displayProps'];
const Paper = /*#__PURE__*/function () {
  const Paper = /*#__PURE__*/forwardRef((_ref, ref) => {
    let {
      as,
      children,
      elevation,
      hoverable,
      ...props
    } = _ref;
    const [className, style, rest] = system(props, SYSTEM_PROPS);
    const classnames = {
      [styles.root]: true,
      [styles.wrapper]: !props.borderRadius,
      [styles.shadowInset1]: elevation === -1,
      [styles.shadow0]: elevation === 0,
      [styles.shadow1]: elevation === 1,
      [styles.shadow2]: elevation === 2,
      [styles.shadow3]: elevation === 3,
      [styles.hoverable]: !!hoverable
    };
    return /*#__PURE__*/React.createElement(Base, _extends({
      as: as,
      className: cx(classnames, className),
      style: style,
      ref: ref
    }, rest), children);
  });
  Paper.displayName = 'Paper';
  Paper.identifier = Paper.displayName; // used in docs website
  Paper.clonableProps = SYSTEM_PROPS;
  Paper.defaultProps = {
    as: 'div',
    elevation: 1,
    hoverable: false,
    display: 'block'
  };
  return Paper;
}();
export default Paper;